import React from 'react'
import './buttonText.scss'
import PropTypes from 'prop-types'
import ButtonBase from "../ButtonBase";

const ButtonText = ({ children, className, ...rest }) => {
  return <ButtonBase className={`Suc-button-text ${className}`} {...rest}>{children}</ButtonBase>
}

ButtonText.propTypes = {
  /** custom classname */
  className: PropTypes.string,
  /** disabled state */
  disabled: PropTypes.bool,
}

ButtonText.defaultProps = {
  className: '',
  disabled: false
}

export default ButtonText
